import React from "react";

function bookHtml() {
  return (
    <div style={{fontSize: '1.2em'}}>
      <div style={{marginBottom: '10px'}}>This companion book includes:</div>
      <ul>
        <li>Illustrated lesson notes</li>
        <li>Lesson worksheets</li>
        <li>Practice exercises</li>
        <li>Review worksheets</li>
        <li>Suggested pacing guide</li>
        <li>Formula and resource worksheets</li>
      </ul>
    </div>
  );
}

const scriptUrl = "https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=";
const bookHost = "https://online.flippingbook.com/view/";
const productHost = "https://www.thinkwellhomeschool.com/products/";

export default {
  AL1_SUB_FULL: {
    1: {
      title: "Algebra 1 Companion Book, Chapters 1 - 5",
      productUrl: productHost + "algebra-1-companion-book-volume-1",
      bookUrl: bookHost + "564708722",
      scriptUrl: scriptUrl + "564708722",
      fboId: "9e622af6e0",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 1 Companion Book, Chapters 6 - 10",
      productUrl: productHost + "algebra-1-companion-book-volume-2",
      bookUrl: bookHost + "1025986392",
      scriptUrl: scriptUrl + "1025986392",
      fboId: "95b2fa48a1",
      html: bookHtml,
      volume: 2
    }
  },
  AL2_SUB_FULL: {
    1: {
      title: "Algebra 2 Companion Book, Chapters 1 - 5",
      productUrl: productHost + "algebra-2-companion-book-volume-1",
      bookUrl: bookHost + "570364034",
      scriptUrl: scriptUrl + "570364034",
      fboId: "9b90090fd2",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 2 Companion Book, Chapters 6 - 9",
      productUrl: productHost + "algebra-2-companion-book-volume-2",
      bookUrl: bookHost + "805582676",
      scriptUrl: scriptUrl + "805582676",
      fboId: "6dcd66e003",
      html: bookHtml,
      volume: 2
    }
  },
  GEO_SUB_FULL: {
    1: {
      title: "Geometry Companion Book, Chapters 1 - 5",
      productUrl: productHost + "geometry-companion-book-volume-1",
      bookUrl: bookHost + "406820671",
      scriptUrl: scriptUrl + "406820671",
      fboId: "b94b908558",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Geometry Companion Book, Chapters 6 - 10",
      productUrl: productHost + "geometry-companion-book-volume-2",
      bookUrl: bookHost + "406169011",
      scriptUrl: scriptUrl + "406169011",
      fboId: "283168f1dd",
      html: bookHtml,
      volume: 2
    }
  },
  AL1H_SUB_FULL: {
    1: {
      title: "Honors Algebra 1 Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-algebra-1-companion-book-volume-1",
      bookUrl: bookHost + "420765151",
      scriptUrl: scriptUrl + "420765151",
      fboId: "02a17ab319",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Algebra 1 Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-algebra-1-companion-book-volume-2",
      bookUrl: bookHost + "420735026",
      scriptUrl: scriptUrl + "420735026",
      fboId: "d59f67844d",
      html: bookHtml,
      volume: 2
    }
  },
  AL2H_SUB_FULL: {
    1: {
      title: "Honors Algebra 2 Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-algebra-2-companion-book-volume-1",
      bookUrl: bookHost + "406061530",
      scriptUrl: scriptUrl + "406061530",
      fboId: "24de236a17",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Algebra 2 Companion Book, Chapters 7 - 14",
      productUrl: productHost + "honors-algebra-2-companion-book-volume-2",
      bookUrl: bookHost + "406488699",
      scriptUrl: scriptUrl + "406488699",
      fboId: "d30352fae2",
      html: bookHtml,
      volume: 2
    }
  },
  GEOH_SUB_FULL: {
    1: {
      title: "Honors Geometry Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-geometry-companion-book-volume-1",
      bookUrl: bookHost + "25050817",
      scriptUrl: scriptUrl + "25050817",
      fboId: "953ec4eaf9",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Geometry Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-geometry-companion-book-volume-2",
      bookUrl: bookHost + "24403033",
      scriptUrl: scriptUrl + "24403033",
      fboId: "f8ffed8d68",
      html: bookHtml,
      volume: 2
    }
  },
  AL1R_SUB_FULL: {
    1: {
      title: "Algebra 1 Readiness",
      productUrl: productHost + "algebra-1-readiness-study-guide",
      bookUrl: bookHost + "882863563",
      scriptUrl: scriptUrl + "882863563",
      fboId: "a9882a29ea",
      html: bookHtml,
      volume: 1
    }
  },
  AL1S_SUB_FULL: {
    1: {
      title: "Algebra 1 Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "457810565",
      scriptUrl: scriptUrl + "457810565",
      fboId: "fd331a8415",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 1 Summer Edition Companion Book, Chapters 6 - 10",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "817791474",
      scriptUrl: scriptUrl + "817791474",
      fboId: "a7b03e9acb",
      html: bookHtml,
      volume: 2
    }
  },
  AL2S_SUB_FULL: {
    1: {
      title: "Algebra 2 Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "898466145",
      scriptUrl: scriptUrl + "898466145",
      fboId: "5f3dc4b5a6",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 2 Summer Edition Companion Book, Chapters 6 - 9",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "898181195",
      scriptUrl: scriptUrl + "898181195",
      fboId: "b84cec3838",
      html: bookHtml,
      volume: 2
    }
  },
  GEOS_SUB_FULL: {
    1: {
      title: "Geometry Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "1057265548",
      scriptUrl: scriptUrl + "1057265548",
      fboId: "3ccccfcae8",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Geometry Summer Edition Companion Book, Chapters 6 - 12",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "1057022609",
      scriptUrl: scriptUrl + "1057022609",
      fboId: "5e5dbafc06",
      html: bookHtml,
      volume: 2
    }
  },
  G6M_SUB_FULL: {
    1: {
      title: "6th Grade Math Companion Book, Chapters 1 - 5",
      productUrl: productHost + "grade-6th-math-companion-book-volume-1",
      bookUrl: bookHost + "604339787",
      scriptUrl: scriptUrl + "604339787",
      fboId: "fb7f74a253",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "6th Grade Math Companion Book, Chapters 6 - 11",
      productUrl: productHost + "grade-6-math-companion-book-volume-2",
      bookUrl: bookHost + "604918913",
      scriptUrl: scriptUrl + "604918913",
      fboId: "cbcf28e873",
      html: bookHtml,
      volume: 2
    }
  },
  G6MH_SUB_FULL: {
    1: {
      title: "Honors 6th Grade Math Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-grade-6th-math-companion-book-volume-1",
      bookUrl: bookHost + "930043383",
      scriptUrl: scriptUrl + "930043383",
      fboId: "1876ed73b5",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors 6th Grade Math Companion Book, Chapters 7 - 13",
      productUrl: productHost + "honors-grade-6-math-companion-book-volume-2",
      bookUrl: bookHost + "687817738",
      scriptUrl: scriptUrl + "687817738",
      fboId: "59f0ada31b",
      html: bookHtml,
      volume: 2
    }
  },
  G7M_SUB_FULL: {
    1: {
      title: "7th Grade Math Companion Book, Chapters 1 - 5",
      productUrl: productHost + "7th-grade-math-companion-book-volume-1",
      bookUrl: bookHost + "617004718",
      scriptUrl: scriptUrl + "617004718",
      fboId: "3f65c3a27e",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "7th Grade Math Companion Book, Chapters 6 - 10",
      productUrl: productHost + "7th-grade-math-companion-book-volume-2",
      bookUrl: bookHost + "436948542",
      scriptUrl: scriptUrl + "436948542",
      fboId: "8121a79d82",
      html: bookHtml,
      volume: 2
    }
  },
  G7MH_SUB_FULL: {
    1: {
      title: "Honors 7th Grade Math Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-7th-grade-math-companion-book-volume-1",
      bookUrl: bookHost + "168794635",
      scriptUrl: scriptUrl + "168794635",
      fboId: "03215e6298",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors 7th Grade Math Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-7th-grade-math-companion-book-volume-2",
      bookUrl: bookHost + "168776249",
      scriptUrl: scriptUrl + "168776249",
      fboId: "7a0b5a9edb",
      html: bookHtml,
      volume: 2
    }
  },
  G8M_SUB_FULL: {
    1: {
      title: "Prealgebra (8th Grade Math) Companion Book, Chapters 1 - 6",
      productUrl: productHost + "prealgebra-companion-book-vol-1",
      bookUrl: bookHost + "610866522",
      scriptUrl: scriptUrl + "610866522",
      fboId: "4b2357ca8e",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Prealgebra (8th Grade Math) Companion Book, Chapters 7 - 11",
      productUrl: productHost + "prealgebra-companion-book-vol2",
      bookUrl: bookHost + "610625094",
      scriptUrl: scriptUrl + "610625094",
      fboId: "84d08509c5",
      html: bookHtml,
      volume: 2
    }
  },
  G8MH_SUB_FULL: {
    1: {
      title: "Honors Prealgebra (8th Grade Math) Companion Book, Chapters 1 - 7",
      productUrl: productHost + "honors-prealgebra-companion-book-volume-1",
      bookUrl: bookHost + "469415499",
      scriptUrl: scriptUrl + "469415499",
      fboId: "c089af43cd",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Prealgebra (8th Grade Math) Companion Book, Chapters 8 - 14",
      productUrl: productHost + "honors-prealgebra-companion-book-volume-2",
      bookUrl: bookHost + "469026263",
      scriptUrl: scriptUrl + "469026263",
      fboId: "083707b926",
      html: bookHtml,
      volume: 2
    }
  }
};
